import { ADULTS, CHILDREN, OCCUPANCY_RANGE } from '../constants';
import { makeRouteQueryFromStore } from './filterParser';

const validateGuestRange = (group, min, max) => {
	const [numberOfGuest] = group || [];
	const inRange = numberOfGuest >= min && numberOfGuest <= max;
	return group && !inRange;
};

const validationTotal = (adults = [0], children = [0]) => {
	return Number(adults[0]) + Number(children[0]) > OCCUPANCY_RANGE.max;
};

const isValidAdults = (adults) => {
	const min = OCCUPANCY_RANGE.adults.min;
	const max = OCCUPANCY_RANGE.adults.max + 1;
	return validateGuestRange(adults, min, max);
};

const isValidChildren = (children, adults) => {
	const min = OCCUPANCY_RANGE.children.min + 1;
	const max = OCCUPANCY_RANGE.children.max + 1;
	return validateGuestRange(children, min, max) || (children && (!adults || validationTotal(adults, children)));
};

export const validateRulesOccupancy = (searchQuery) => {
	const search = { ...searchQuery };
	const children = search[CHILDREN] || null;
	let adults = search[ADULTS] || null;

	if (adults && isValidAdults(adults)) {
		delete search[ADULTS];
		adults = null;
	}
	if (children && isValidChildren(children, adults)) {
		delete search[CHILDREN];
	}

	return makeRouteQueryFromStore({ search })?.split('?')?.[1] || '';
};
